if (!customElements.get('searange-language-switcher')) {
  customElements.define(
    'searange-language-switcher',
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('submit', (event) => {
          // Variant selections and search terms can change after the header renders.
          const returnTo = this.querySelector('input[name="return_to"]');
          if (returnTo) returnTo.value = window.location.pathname + window.location.search;
          const previewUrl = customElements.get('localization-form')?.previewLanguageUrl(
            event.submitter?.value,
            event.submitter?.dataset.rootUrl
          );
          if (previewUrl) {
            event.preventDefault();
            window.location.assign(previewUrl);
          }
        });
      }
    }
  );
}
